<div class="m-4 px-md-2 px-md-0">
  <h6 class="title text-center">{{ 'pricing.title' | translate }}</h6>
  <p class="text-center">
    {{ 'pricing.subtitle' | translate }}
  </p>

  <div class="row mx-sm-3">
    <div class="col-12 col-sm-6 col-lg-4 py-2" *ngFor="let item of pricingList">
      <div class="price-card" [ngClass]="{ pro: item.key === 'pro' }">
        <div class="d-flex align-items-center">
          <h6 class="name">{{ 'pricing.packages.' + item.key + '.name' | translate }}</h6>
          <p class="popular" *ngIf="item.key === 'pro'">
            {{ 'pricing.popular' | translate }}
          </p>
        </div>

        <div class="price-section">
          <div class="d-flex align-items-baseline gap-2" *ngIf="item.sessions">
            <span class="price-amount">{{ item.price }}</span>
            <span class="currency">{{ 'pricing.egp' | translate }}</span>
            <span class="sessions">/{{ item.sessions }} {{ (item.sessions === 1 ? 'pricing.session' :
              'pricing.sessions') | translate }}</span>
          </div>
          <span class="customized-price" *ngIf="!item.sessions">
            {{ 'pricing.customized' | translate }}
          </span>
        </div>

        <p class="description">
          {{ 'pricing.packages.' + item.key + '.title' | translate }}
        </p>

        <div class="features-list">
          <div class="feature-item" *ngFor="let feature of item.features; let i = index">
            <i class="bi bi-check-circle text-success me-2"></i>
            <span>{{ 'pricing.packages.' + item.key + '.features.' + i | translate }}</span>
          </div>
        </div>

        <div class="text-center mt-auto">
          <a href="https://wa.me/+201555842727" target="_blank">
            <button class="contact-btn" [ngClass]="{
                'gradient-button': item.key === 'pro',
                'border-button': item.key !== 'pro'
              }">
              {{ 'pricing.contactUs' | translate }}
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>